export default __webpack_public_path__ + "36943fad223c6a570bef98affc30ae12.JPG";